// SuccessCourse.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { initMetaPixel, trackPurchase } from "./metaPixel";
import { createTranslator, useLanguage } from '../i18n/LanguageContext';
import { successTranslations } from '../i18n/translations';

const SuccessCourse = () => {
  const navigate = useNavigate();
  const [isProcessing, setIsProcessing] = useState(true);
  const { language } = useLanguage();
  const t = createTranslator(language, successTranslations);

  useEffect(() => {
    setTimeout(() => {
      setIsProcessing(false);
    }, 3000);
    setTimeout(() => {
      navigate('/');
    }, 8000);
  }, [navigate]);

  useEffect(() => {
    initMetaPixel();
  
    const alreadyTracked = sessionStorage.getItem("purchase_tracked_course");
  
    if (!alreadyTracked) {
      setTimeout(() => {
        trackPurchase("course");
        sessionStorage.setItem("purchase_tracked_course", "true");
      }, 1500);
    }
  }, []);

  return (
    <section className="bg-white text-black min-h-screen flex flex-col justify-center items-center px-4">
      {isProcessing ? (
        <div className="text-center">
          <div className="spinner border-4 border-t-[#4c2f8e] border-gray-300 rounded-full h-16 w-16 mb-6 animate-spin"></div>
          <h2 className="text-2xl font-semibold text-[#4c2f8e]">{t('registrationValidation')}</h2>
          <p className="text-gray-600 mt-4">{t('registrationProcessing')}</p>
        </div>
      ) : (
        <div className="text-center">
          <h1 className="text-4xl font-bold text-[#4c2f8e] mb-4">{t('courseThanks')}</h1>
          <p className="text-lg text-gray-700 mb-2">
            {t('courseEmail')}
          </p>
          <p className="text-gray-500">{t('redirectAutomatic')}</p>
        </div>
      )}
      <style>{`
        .spinner {
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </section>
  );
};

export default SuccessCourse;
